import SettingsContent from './SettingsContent'
export default SettingsContent
